import { render } from "./VChipProjectsList.vue?vue&type=template&id=f4c933ee&scoped=true"
import script from "./VChipProjectsList.vue?vue&type=script&lang=js"
export * from "./VChipProjectsList.vue?vue&type=script&lang=js"

import "./VChipProjectsList.vue?vue&type=style&index=0&id=f4c933ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c933ee"]])

export default __exports__